
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { settings } from '../../app.settings';
import { Program, toApi, fromApi } from '../../shared/models/program';
import { BaseService } from '~common/app/shared/services/base.service';
import { NaiveParameterCodec } from '~common/app/shared/utils/encoding';
import { Segment } from 'app/shared/models/segment';

const API_PATH = settings.api.url + '/programs';
const API_PATH_PERKS = settings.api.urlPerks + '/programs';

@Injectable()
export class ProgramService extends BaseService {

  constructor(private http: HttpClient) {
    super();
  }

  get(): Observable<any> {
    return this.http.get(API_PATH + '/me').pipe(map(response => {
      response = fromApi(response);

      return this.hydrate(Program, response);
    }));
  }

  create(data): Observable<any> {
    return this.http.post(API_PATH, toApi(data));
  }

  update(data): Observable<any> {
    return this.http.put(API_PATH + '/me', toApi(data));
  }

  getAudienceByStrategy(strategyId: string, segmentIds: any[], key: string = 'strategy_id'): Observable<any> {
    let apiParams = new HttpParams({ encoder: new NaiveParameterCodec() });

    apiParams = apiParams.append(key, strategyId);

    segmentIds.forEach((segmentId) => {
      apiParams = apiParams.append('segment', segmentId);
    });

    return this.http.get(API_PATH_PERKS + '/me/audience', {
      params: apiParams
    });
  }

  getAudienceByAwinStrategy(strategyId: string, segmentIds: any[]): Observable<any> {
    return this.getAudienceByStrategy(strategyId, segmentIds, 'affiliation_strategy_id');
  }

  getAudienceByEvoStrategy(strategyId: string, segmentIds: any[]): Observable<any> {
    return this.getAudienceByStrategy(strategyId, segmentIds, 'voucher_strategy_id');
  }

  optOutConsumer(consumerId: string, level: string): Observable<any> {
    return this.http.delete(API_PATH + '/me/consumers/' + consumerId + '/consent/' + level)
  }
}
